import { render } from "./PpcProductPrioritization.vue?vue&type=template&id=4cfd1c80&scoped=true"
import script from "./PpcProductPrioritization.vue?vue&type=script&lang=js"
export * from "./PpcProductPrioritization.vue?vue&type=script&lang=js"

import "./PpcProductPrioritization.vue?vue&type=style&index=0&id=4cfd1c80&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cfd1c80"]])

export default __exports__